export const environment = {
  production: false,
  apiUrl: 'https://api.test.pharmacistsplus.eye-apps.com',
};
